import { render, staticRenderFns } from "./WkUser.vue?vue&type=template&id=7012523c&scoped=true&"
import script from "./WkUser.vue?vue&type=script&lang=js&"
export * from "./WkUser.vue?vue&type=script&lang=js&"
import style0 from "./WkUser.vue?vue&type=style&index=0&id=7012523c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012523c",
  null
  
)

component.options.__file = "WkUser.vue"
export default component.exports